import React from 'react';
import { Btn } from './StyledComponent';
import { Grow } from '@mui/material';

const ButtonCom = ({ disabled, backgroundColor, color, type, btnTitle, onClickHandler }) => {
	return (
		<Grow
			in={btnTitle}
			style={{ transformOrigin: '0 0 0' }}
			{...(btnTitle ? { timeout: 1000 } : {})}
		>
			<Btn
				variant='contained'
				type={type || 'button'}
				onClick={onClickHandler}
				disabled={disabled}
				backgroundColor={backgroundColor}
				color={color}
				className='font-face-M'>
				{btnTitle}
			</Btn>
		</Grow>
	);
};

export default ButtonCom;
